import React, { useState, useEffect } from "react";
import { Box, Flex } from "@chakra-ui/react";
import SmoothScrolling from "../../smoothScroll";
import HeaderLink from "./HeaderLink";

const HeaderMobileCourtine = ({ closeMobile }) => {
  const [animStarted, setAnimStarted] = useState(false);

  useEffect(() => {
    setAnimStarted(true);
  }, []);

  const scrollTo = (id) => {
    closeMobile();
    SmoothScrolling.scrollTo(id);
  };

  return (
    <Box
      bg="#331F12"
      pos="fixed"
      top="62px"
      left={0}
      right={0}
      bottom={0}
      height="calc(100% - 60px)"
      width="100%"
      transform={animStarted ? "translateY(0)" : "translateY(-100%)"}
      transition=".3s transform ease"
    >
      <Flex
        h="100%"
        flexDirection="column"
        alignItems="center"
        pt="15%"
        pb="30px"
        overflow="auto"
      >
        {/* <HeaderLink>Inscrição</HeaderLink> */}
        <HeaderLink onClick={() => scrollTo("votacao")} my={4}>
          Resultado
        </HeaderLink>
        <HeaderLink onClick={() => scrollTo("tema")} my={4}>
          Tema
        </HeaderLink>
        <HeaderLink onClick={() => scrollTo("regulamento")} my={4}>
          Regulamento
        </HeaderLink>
        <HeaderLink onClick={() => scrollTo("premio")} my={4}>
          Prêmio
        </HeaderLink>
        <HeaderLink onClick={() => scrollTo("jurados")} my={4}>
          Jurados
        </HeaderLink>
        <HeaderLink onClick={() => scrollTo("etapas")} my={4} noBorder>
          Etapas
        </HeaderLink>
      </Flex>
    </Box>
  );
};

export default HeaderMobileCourtine;
